import React, { FC, useEffect, useMemo } from "react";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { useTypedSelector } from "../../redux";
import { Configuration, typeCadaster } from "../../clients/FirebaseClient/types";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { Colors } from "../../styles";

interface InterceptorProps {
    creating?: boolean;
    uid?: string;
    isAnonymous?: boolean;
    configurations: { [key: string]: Configuration };
    configurationId?: string;
    powerOrGasAvailable: boolean;
    navigate: NavigateFunction;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    params?: { [key: string]: any };
}

type Props = {
    shouldIntercept: (props: InterceptorProps) => boolean;
    interceptor: (props: InterceptorProps) => void;
    children: React.ReactElement;
};

const useStyles = makeStyles(() => ({
    root: {
        color: Colors.mellowYellow,
    },
}));

export const InterceptableComponent: FC<Props> = (props: Props) => {
    const classes = useStyles();
    const params = useParams();
    const navigate = useNavigate()
    const stateProps = useTypedSelector((state) => ({
        uid: (state.auth.loggedIn && state.auth.uid) || undefined,
        isAnonymous: (state.auth.loggedIn && state.auth.isAnonymous) || undefined,
        creating: state.configuration.creating,
        configurations: state.configuration.configurations,
        configurationId: state.configuration.currentConfigurationId,
        powerOrGasAvailable:
            state.configuration.configurations[state.configuration.currentConfigurationId || ""]
                ?.state.buildingAddress?.state.type === typeCadaster ||
            state.configuration.productPartners?.gas?.foreignProvider === false ||
            state.configuration.productPartners?.power?.foreignProvider === false,
    }));
    const interceptorProps = useMemo(
        () => ({
            params,
            ...stateProps,
            navigate,
        }),
        [params, stateProps, navigate],
    );

    const willIntercept = props.shouldIntercept(interceptorProps);
    useEffect(() => {
        if (willIntercept) {
            // console.info("intercepting", props.path, interceptorProps);
            props.interceptor(interceptorProps);
        }
    }, [willIntercept, interceptorProps, props]);

    if (willIntercept) {
        return (
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "#ffffff99",
                    display: "flex",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    justifyContent: "center",
                    alignItems: "center",
                    justifyItems: "center",
                    flexDirection: "column",
                }}
            >
                <CircularProgress variant="indeterminate" className={classes.root} />
            </div>
        );
    } else {
        return props.children;
    }
};
